import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import TCPDF from '../../documents/TRO-subscription-website-terms-and-conditions.pdf';

class Services extends Component {
  render() {
    return (
        <div className="main-content" style={{backgroundImage: "url("+require("../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
            backgroundPosition: "center center"}}>
            {/*<div className="main-content">*/}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Terms and Conditions for using Tattoo Release Online"
                category="Here is a link to our Terms and Conditions that all users agree to when registering to use our software"
                content={
                  <div className="typo-line">
                    <p>
                        <a href = {TCPDF} target = "_blank">Download our Terms and Conditions</a>
                    </p>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Legal.jsx